var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ucrs-prevNext"},[_c('UcrsAnchor',{attrs:{"to":_vm.prev,"label":{
      desktop: 'Precedente',
      mobile: 'Prec',
    },"role":"link","aria-label":"Annuncio precedente","disabled":!_vm.prev,"icon-position":"left","icon":"angle-left"},on:{"click":_vm.onPrevClick}}),_vm._v(" "),_c('UcrsAnchor',{staticClass:"order-2",attrs:{"to":_vm.next,"label":{
      desktop: 'Successivo',
      mobile: 'Succ',
    },"role":"link","aria-label":"Annuncio successivo","disabled":!_vm.next},on:{"click":_vm.onNextClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }